export function getQueryParams() {
    const params = {};
    const queryString = window.location.search.substring(1);
    const queryParts = queryString.split('&');
    queryParts.forEach(part => {
        const [rawKey, rawValue] = part.split('=');
        if (rawKey && rawValue !== undefined) {
            const key = decodeURIComponent(rawKey.replace(/\+/g, ' '));
            const value = decodeURIComponent(rawValue.replace(/\+/g, ' '));
            params[key] = value;
        }
    });
    return params;
}
